import React from "react";
import DashboardBarChart from "../../../../components/charts/DashboardBarChart";

export default function WidgetParticipantsChart() {
  return (
    <div className="">
      

      <div className="box-body chart-responsive">
        <DashboardBarChart />
      </div>
    </div>
  );
}
